import axiosInstance from "../configuration/api";

export const search = async (query: string) => {
  try {
    const baseUrl = process.env.REACT_APP_API_HOST;
    const response = await axiosInstance.get(`${baseUrl}/api/v1/search`, {
      params: { query },
    });
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Search failed");
  }
};
